<ng-container>
  <div class="wcw-flex-col">
    <div class="clearfix wcw-flex-clearfix">
      <div
        #cardWrapper
        class="card customCard animate__animated animate__duration-2s"
        [ngClass]="{
          animate__fadeIn: !hide,
          animate__fadeOut: shouldPlayFadeOut,
          'animate__delay-1s': !hide
        }"
        (animationend)="onAnimationEnd($event)"
      >
        <div class="card-body">
          <h5 class="card-title card-title-main mb-3">{{ title }}</h5>
          <h5 *ngIf="subTitle !== ''" class="card-subtitle card-title-main mb-3">
            {{ subTitle }}
          </h5>
          <div class="hide-me" style="visibility: hidden; height: 0px" *ngIf="hide"></div>
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</ng-container>
